import React, { useEffect, useState } from 'react'
import { SaveSubjects, updateSubjects } from '../../../services/CommonService';
import { ToastContainer, toast } from 'react-toastify';

function AddSubjects({ updateprop }) {
  const notifyTopFullWidth = (message) => {
    toast.info(message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };


  const fields = {
    name: '',
    status: '',
    position: '',
  }
  const errors = {
    name: '',
    status: '',
    position: '',
  }

  const [formfields, setFromFields] = useState(fields);
  const [errorFields, setErrorFields] = useState(errors);

  useEffect(() => {
    setFieldData();
  }, []);


  const { name, status, position } = formfields;

  const setFieldData = async () => {
    if (updateprop?.id) {
      setFromFields(updateprop)
    }

  }

  const validateForm = async () => {
    let fields = formfields;
    let errors = {};
    let formIsValid = true;

    if (!fields["position"]) {
      formIsValid = false;
      errors["position"] = "*Please enter display position name .";
    }

    if (!fields["name"]) {
      formIsValid = false;
      errors["name"] = "*Please enter subject name .";
    }
    if (!fields["status"]) {
      formIsValid = false;
      errors["status"] = "*Please select status .";
    }

    setErrorFields(errors)
    return formIsValid;

  }
  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFromFields((prevState) => ({
      ...prevState,
      [name]: value
    }));

  }
  const submitForm = async () => {
    // console.log(formfields);
    const isValid = await validateForm();
    if (isValid) {
      if (!formfields.id) {
        //save
        const Response = await SaveSubjects(formfields);
        if (Response.data.id) {
          notifyTopFullWidth("Data saved successfully");
          formfields.id = Response.data.id;
        }

      } else {
        const Response = await updateSubjects(formfields);
        if (Response.data.id) {
          notifyTopFullWidth("Data updated successfully");
          formfields.id = Response.data.id;
        }


      }

    }

  }
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="form-group mb-3 row">
        <label
          className="col-lg-4 col-form-label"
          htmlFor="val-username"
        >
          Display Position
        </label>
        <div className="col-lg-6">
          <input component="input"
            placeholder="Display position"
            name="position"
            className="form-control"

            value={position} maxLength={50} onChange={handleChange} />

        </div>
        <div className="errorMsg">{errorFields.position}</div>
      </div>
      <br />

      <div className="form-group mb-3 row">
        <label
          className="col-lg-4 col-form-label"
          htmlFor="val-username"
        >
          Subject Name
        </label>
        <div className="col-lg-6">
          <input component="input"
            placeholder="subject name"
            name="name"
            className="form-control"

            value={name} maxLength={50} onChange={handleChange} />


        </div>
        <div className="errorMsg">{errorFields.name}</div>
      </div>
      <br />

      <div className="form-group mb-3 row">
        <label
          className="col-lg-4 col-form-label"
          htmlFor="val-username"
        >
          Status
        </label>
        <div className="col-lg-6">
          <select
            className="form-control" name='status'
            onChange={handleChange} value={status}>
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>

        </div>
        <div className="errorMsg">{errorFields.status}</div>
      </div>
      <br />
      <div className="form-group">
        <button onClick={submitForm} className="btn btn-primary" type="button"
        >Save</button>
      </div>

    </>
  )
}

export default AddSubjects